let country_code = {"AF": "Afghanistan","AX": "Aland Islands","AL": "Albania","DZ": "Algeria","AS": "American Samoa","AD": "Andorra","AO": "Angola","AI": "Anguilla","AQ": "Antarctica","AG": "Antigua And Barbuda","AR": "Argentina","AM": "Armenia","AW": "Aruba","AU": "Australia","AT": "Austria","AZ": "Azerbaijan","BS": "Bahamas","BH": "Bahrain","BD": "Bangladesh","BB": "Barbados","BY": "Belarus","BE": "Belgium","BZ": "Belize","BJ": "Benin","BM": "Bermuda","BT": "Bhutan","BO": "Bolivia","BA": "Bosnia And Herzegovina","BW": "Botswana","BV": "Bouvet Island","BR": "Brazil","IO": "British Indian Ocean Territory","BN": "Brunei Darussalam","BG": "Bulgaria","BF": "Burkina Faso","BI": "Burundi","KH": "Cambodia","CM": "Cameroon","CA": "Canada","CV": "Cape Verde","KY": "Cayman Islands","CF": "Central African Republic","TD": "Chad","CL": "Chile","CN": "China","CX": "Christmas Island","CC": "Cocos (Keeling) Islands","CO": "Colombia","KM": "Comoros","CG": "Congo","CD": "Congo, Democratic Republic","CK": "Cook Islands","CR": "Costa Rica","CI": "Cote D\"Ivoire","HR": "Croatia","CU": "Cuba","CY": "Cyprus","CZ": "Czech Republic","DK": "Denmark","DJ": "Djibouti","DM": "Dominica","DO": "Dominican Republic","EC": "Ecuador","EG": "Egypt","SV": "El Salvador","GQ": "Equatorial Guinea","ER": "Eritrea","EE": "Estonia","ET": "Ethiopia","FK": "Falkland Islands (Malvinas)","FO": "Faroe Islands","FJ": "Fiji","FI": "Finland","FR": "France","GF": "French Guiana","PF": "French Polynesia","TF": "French Southern Territories","GA": "Gabon","GM": "Gambia","GE": "Georgia","DE": "Germany","GH": "Ghana","GI": "Gibraltar","GR": "Greece","GL": "Greenland","GD": "Grenada","GP": "Guadeloupe","GU": "Guam","GT": "Guatemala","GG": "Guernsey","GN": "Guinea","GW": "Guinea-Bissau","GY": "Guyana","HT": "Haiti","HM": "Heard Island & Mcdonald Islands","VA": "Holy See (Vatican City State)","HN": "Honduras","HK": "Hong Kong","HU": "Hungary","IS": "Iceland","IN": "India","ID": "Indonesia","IR": "Iran, Islamic Republic Of","IQ": "Iraq","IE": "Ireland","IM": "Isle Of Man","IL": "Israel","IT": "Italy","JM": "Jamaica","JP": "Japan","JE": "Jersey","JO": "Jordan","KZ": "Kazakhstan","KE": "Kenya","KI": "Kiribati","KR": "Korea","KP": "North Korea","KW": "Kuwait","KG": "Kyrgyzstan","LA": "Lao People\"s Democratic Republic","LV": "Latvia","LB": "Lebanon","LS": "Lesotho","LR": "Liberia","LY": "Libyan Arab Jamahiriya","LI": "Liechtenstein","LT": "Lithuania","LU": "Luxembourg","MO": "Macao","MK": "Macedonia","MG": "Madagascar","MW": "Malawi","MY": "Malaysia","MV": "Maldives","ML": "Mali","MT": "Malta","MH": "Marshall Islands","MQ": "Martinique","MR": "Mauritania","MU": "Mauritius","YT": "Mayotte","MX": "Mexico","FM": "Micronesia, Federated States Of","MD": "Moldova","MC": "Monaco","MN": "Mongolia","ME": "Montenegro","MS": "Montserrat","MA": "Morocco","MZ": "Mozambique","MM": "Myanmar","NA": "Namibia","NR": "Nauru","NP": "Nepal","NL": "Netherlands","AN": "Netherlands Antilles","NC": "New Caledonia","NZ": "New Zealand","NI": "Nicaragua","NE": "Niger","NG": "Nigeria","NU": "Niue","NF": "Norfolk Island","MP": "Northern Mariana Islands","NO": "Norway","OM": "Oman","PK": "Pakistan","PW": "Palau","PS": "Palestinian Territory, Occupied","PA": "Panama","PG": "Papua New Guinea","PY": "Paraguay","PE": "Peru","PH": "Philippines","PN": "Pitcairn","PL": "Poland","PT": "Portugal","PR": "Puerto Rico","QA": "Qatar","RE": "Reunion","RO": "Romania","RU": "Russian Federation","RW": "Rwanda","BL": "Saint Barthelemy","SH": "Saint Helena","KN": "Saint Kitts And Nevis","LC": "Saint Lucia","MF": "Saint Martin","PM": "Saint Pierre And Miquelon","VC": "Saint Vincent And Grenadines","WS": "Samoa","SM": "San Marino","ST": "Sao Tome And Principe","SA": "Saudi Arabia","SN": "Senegal","RS": "Serbia","SC": "Seychelles","SL": "Sierra Leone","SG": "Singapore","SK": "Slovakia","SI": "Slovenia","SB": "Solomon Islands","SO": "Somalia","ZA": "South Africa","GS": "South Georgia And Sandwich Isl.","ES": "Spain","LK": "Sri Lanka","SD": "Sudan","SR": "Suriname","SJ": "Svalbard And Jan Mayen","SZ": "Swaziland","SE": "Sweden","CH": "Switzerland","SY": "Syrian Arab Republic","TW": "Taiwan","TJ": "Tajikistan","TZ": "Tanzania","TH": "Thailand","TL": "Timor-Leste","TG": "Togo","TK": "Tokelau","TO": "Tonga","TT": "Trinidad And Tobago","TN": "Tunisia","TR": "Turkey","TM": "Turkmenistan","TC": "Turks And Caicos Islands","TV": "Tuvalu","UG": "Uganda","UA": "Ukraine","AE": "United Arab Emirates","GB": "United Kingdom","US": "United States","UM": "United States Outlying Islands","UY": "Uruguay","UZ": "Uzbekistan","VU": "Vanuatu","VE": "Venezuela","VN": "Vietnam","VG": "Virgin Islands, British","VI": "Virgin Islands, U.S.","WF": "Wallis And Futuna","EH": "Western Sahara","YE": "Yemen","ZM": "Zambia","ZW": "Zimbabwe"};
// let API_url = "http://127.0.0.1:3000";
let API_url = "https://e-sim-api-two.vercel.app";

const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
const requestOptions = { method: "POST", headers: myHeaders, redirect: "follow" };

function getEsimStatus(esim, totalVolume) {
    if (esim.smdpStatus === "RELEASED" && (esim.esimStatus === "IN_USE" || esim.esimStatus === "GOT_RESOURCE") && esim.orderUsage === 0) {
        return "Not Installed";
    } else if (esim.smdpStatus === "ENABLED" && esim.esimStatus === "IN_USE" ) {
        return "Active";
    } else if ((esim.smdpStatus === "ENABLED" || esim.smdpStatus === "DISABLED") && esim.esimStatus === "IN_USE" && esim.orderUsage > 0 && esim.orderUsage < totalVolume) {
        return "Active";
    } else if ((esim.smdpStatus === "ENABLED" || esim.smdpStatus === "DISABLED") && esim.esimStatus === "USED_UP" && esim.orderUsage >= totalVolume) {
        // if(!esim.pack_slug.includes('_Daily') && !esim.pack_slug.includes('_End')){ return "Plan Expired - Top-Up Available" } else{ }
        return "Plan Expired - New eSIM Required" 
    } else if (esim.smdpStatus === "DELETED" ) {
        return "eSIM Deleted";
    } else if (esim.esimStatus === "CREATE") {
        return "Pending";
    } else if (esim.esimStatus === "PAYING") {
        return "Pending";
    } else if (esim.esimStatus === "PAID") {
        return "Pending";
    } else if (esim.esimStatus === "GETTING_RESOURCE") {
        return "Pending";
    } else if (esim.esimStatus === "UNUSED_EXPIRED") {
        // if(!esim.pack_slug.includes('_Daily') && !esim.pack_slug.includes('_End')){ return "Plan Expired - Top-Up Available" } else{ }
        return "Plan Expired - New eSIM Required"
    } else if (esim.esimStatus === "USED_EXPIRED") {
        // if(!esim.pack_slug.includes('_Daily') && !esim.pack_slug.includes('_End')){ return "Plan Expired - Top-Up Available" } else{ }
        return "Plan Expired - New eSIM Required"
    } else if (esim.esimStatus === "CANCEL") {
        // if(!esim.pack_slug.includes('_Daily') && !esim.pack_slug.includes('_End')){ return "Plan Expired - Top-Up Available" }else{ return "Plan Expired - New eSIM Required" }
        return "Plan Canceled - New eSIM Required";
    } else if (esim.esimStatus === "SUSPENDED") {
        return "Plan Expired - New eSIM Required";
    } else if (esim.esimStatus === "REVOKE") {
        return "Plan Expired - New eSIM Required";
    } else {
        // return "Unknown";
        return "Pending";
    }
}
function getCountryName(locationCode, packageName) { 
    // console.log({cc:country_code[locationCode], packageName:removeLastParts(packageName)});
    let res = country_code[locationCode];
    if(res == undefined) res = removeLastParts(packageName)
    return res 
    // return country_code[locationCode] || "Unknown Country" 
}
function formatBytes(bytes) {
    if(bytes < 1){ return '0'; }
    if (bytes < 1024 * 1024) { return (bytes / 1024).toFixed(2) + " KB" } 
    else if (bytes < 1024 * 1024 * 1024) { return (bytes / (1024 * 1024)).toFixed(2) + " MB" } 
    else { return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB" }
}
function formatDateTime(expiredTime, format = "full") {
    const date = new Date(expiredTime);

    // Extract date components
    const datePart = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "2-digit"
    });

    // Extract time components with AM/PM
    const timePart = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
    });

    // Get GMT Offset
    const offsetMinutes = date.getTimezoneOffset();
    const offsetHours = -offsetMinutes / 60;
    const gmtOffset = `GMT${offsetHours >= 0 ? "+" : ""}${offsetHours}`;

    // Return based on the format option
    if (format === "date") return datePart;
    if (format === "time") return `${timePart} ${gmtOffset}`;
    return `${datePart}, ${timePart} ${gmtOffset}`; // Full format
}
function extractLpaValues(lpaString) {
    const parts = lpaString.split("$");

    if (parts.length < 3) { return { firstValue: null, secondValue: null } }

    return {
        first: parts[1], 
        last: parts.slice(2).join("$")
    };
}
function getLastTwoParts(inputStr) {
    const parts = inputStr.replace(/"/g, "").split(" ");
    return parts.slice(-2).join(" ");
}
function removeLastParts(inputStr) {
    const parts = inputStr.replace(/"/g, "").split(" ");
    if (parts.length === 0) return "";
    const lastPart = parts[parts.length - 1];
    return lastPart.includes("GB/") ? parts.slice(0, -1).join(" ") : parts.slice(0, -2).join(" ");
}
function LocationLength(locationString) { return locationString.split(',').length }
function getValueBeforeUnderscore(input) { if (typeof input === 'string') { return input.split('_')[0] } return null }
function getPackageCodeByName(nameToCheck, packageList) {
    const foundItem = packageList.find(item => item.name === nameToCheck);
    return foundItem ? foundItem.packageCode : ''; // Returns packageCode if found, otherwise null
}
// function findMatchingIds(arr1, arr2) {
//     let result = []; // console.log({arr1,arr2});
//     arr1.forEach( i => { let match = arr2.find( a => a.title === i.name ); result.push(match) });
//     return result;
// }
function findMatchingIds(arr1, arr2) { return arr1.map(i => arr2.find(a => a.title === i.name)).filter(Boolean) }
function removeTextFromTitle(title, textToRemove) { return title.replace(textToRemove, '').trim() }
function sortByPrice(products) { return products.sort((a, b) => a.price - b.price) }

window.eSim_fetch_data = async () => {
    let esim_list_elm = document.getElementById('esim_list');
    let iccids = esim_list_elm.dataset.iccids;
    let iccids_arr = iccids.split(',');
    let loaderElm = esim_list_elm.closest('.container').querySelector('.esim_loader');
    let curr_symbol = esim_list_elm.dataset.currSymbol;
    
    if (!loaderElm.classList.contains('esim_loader--active')) {
        loaderElm.classList.add('esim_loader--active');
    }

    let esimCards = [];
    let startTime = performance.now(); // Start timer

    for (let iccid of iccids_arr) {
        try {
            // console.log('Fetching data for ICCID:', iccid);
            let reqHead = { ...requestOptions, body: JSON.stringify({ "iccid": iccid }) };
            let response = await fetch(`${API_url}/api/fetchByICCID`, reqHead);
            let result = await response.json();

            let esimData = {
                smdpStatus: result[0].smdpStatus,
                esimStatus: result[0].esimStatus,
                orderUsage: result[0].orderUsage,
                eid: result[0].eid,
                pack_slug: result[0].packageList[0].slug
            };

            let countryName = getCountryName(result[0].packageList[0].locationCode, result[0].packageList[0].packageName);
            let totalVolume = result[0].totalVolume;
            let dataRemaining = Math.max(0, totalVolume - result[0].orderUsage);
            let esimStatusText = getEsimStatus(esimData, totalVolume);
            let isInstallable = !["SUSPENDED", "REVOKE"].includes(result[0].esimStatus) && !['Plan Expired - New eSIM Required', 'eSIM Deleted', 'Plan Canceled - New eSIM Required','Active', 'Pending'].includes(esimStatusText);
            let isInstalled = ['Active'].includes(esimStatusText);
            // let canTopUp = result[0].supportTopUpType === 2 && !/_Daily|_End/.test(result[0].packageList[0].slug) && !['Plan Expired - New eSIM Required', 'eSIM Deleted', 'Plan Canceled - New eSIM Required'].includes(esimStatusText);
            let canTopUp = result[0].supportTopUpType === 2 && !/_Daily|_End/.test(result[0].packageList[0].slug) && ['Active'].includes(esimStatusText);
            //&& LocationLength(result[0].packageList[0].locationCode) === 1

            let packages_result = '';
            let available_top_ups = [];
            if(canTopUp){
                let packages_reqHead = { ...requestOptions, body: JSON.stringify({ "locationCode": result[0].packageList[0].locationCode,"type": 'TOPUP',"packageCode":"","iccid":iccid }) };
                let packages_response = await fetch(`${API_url}/api/fetchTopUps`, packages_reqHead);
                packages_result = await packages_response.json();
                let packageList_arr = [];

                if(packages_result.success == true){
                    let packageList = packages_result.obj.packageList;
                    packageList_arr = packageList.map(({ name, packageCode }) => ({ name, packageCode }));
                    let prd_handle = result[0].packageList[0].locationCode.toLowerCase();

                    if(LocationLength(result[0].packageList[0].locationCode) > 1 ){ prd_handle = getValueBeforeUnderscore(result[0].packageList[0].slug.toLowerCase()) }
                    // console.log('prd_handle', {prd_handle,iccid} );
                    let prd_response = await fetch(`/products/${prd_handle}_zone.js`, { method: "GET", headers: myHeaders });
                    let prd_result = await prd_response.json();
                    let prd_var_arr = prd_result.variants.map(({ title, id, price }) => ({ title, id, price }));
    
                    available_top_ups = sortByPrice(findMatchingIds(packageList_arr, prd_var_arr));
                    console.log('available_top_ups', {available_top_ups, prd_var_arr, packageList_arr} );
                }
            } 
            // /cart/VARIANT_ID:1?note=ICCID&checkout

            esimCards.push(`
                <div class="esim_card">
                    <div class="esim_card--header">
                        <h3>${countryName} eSIM</h3>
                        <p>${esimStatusText}</p>
                    </div>
                    <div class="esim_card--content">
                        <p><span>ICCID</span><span>${result[0].iccid}</span></p>
                        <p><span>Coverage</span><span>${countryName}</span></p>
                        <p><span>Data Allocation</span><span>${formatBytes(totalVolume)}</span></p>
                        <p><span>Data Remaining</span><span>${formatBytes(dataRemaining)}</span></p>
                        <p><span>Expiry Date</span><span>${formatDateTime(result[0].expiredTime, "date")}</span></p>
                    </div>
                    <div class="esim_card--footer">
                        <a href="/pages/esim-details?iccid=${result[0].iccid}" class="esim_card--btn esim_card--detail_btn">Details</a>
                        ${isInstallable ? `<a href="/pages/esim-details?iccid=${result[0].iccid}" class="esim_card--btn esim_card--install_btn">Install</a>` : ''}
                        ${isInstalled ? `<a class="esim_card--btn esim_card--install_btn esim_card--install_btn--disabled">eSIM INSTALLED</a>` : ''}
                        ${canTopUp && available_top_ups.length > 0 ? `<button class="esim_card--btn esim_card--top_up_btn">Top Up</button>` : ''}
                        ${canTopUp && available_top_ups.length > 0 ? `
                            <div class="esim_topup_popup" style="display:none;">
                                <div class="esim_topup_popup--overlay"></div>
                                <div class="esim_topup_popup--items">
                                    <div class="esim_topup_popup--close_btn"><p style="margin: 0;">Select here</p><svg fill="#000" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 32 32" xml:space="preserve"><path d="M20.949 9.637 16 14.586l-4.949-4.949-1.414 1.414L14.586 16l-4.949 4.949 1.414 1.414L16 17.414l4.949 4.949 1.414-1.414L17.414 16l4.949-4.949z"/><path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0m0 29.5C8.544 29.5 2.5 23.456 2.5 16S8.544 2.5 16 2.5 29.5 8.544 29.5 16 23.456 29.5 16 29.5"/></svg></div>
                                    ${available_top_ups.map(e => `<a href="/cart/${e.id}:1?note=${iccid}&checkout" class="esim_topup_popup--item">${removeTextFromTitle(e.title, countryName)} - ${curr_symbol}${(e.price / 100).toFixed(2)}</a>`).join('')}
                                </div>
                            </div>
                        ` : ''}
                    </div>
                </div>
            `);
        } catch (error) {
            console.error(`Error fetching eSIM data for ICCID ${iccid}:`, error);
        }
    }

    let endTime = performance.now(); // End timer //{startTime,endTime}
    console.log(`Time taken to Fetch all ICCIDs: ${((endTime - startTime).toFixed(2) / 1000 ).toFixed(2)} s`);

    loaderElm.classList.remove('esim_loader--active');
    esim_list_elm.innerHTML = esimCards.join('');
};

const esim_detail_page = async () => {
    let esim_details_html = '';
    let esim_detail_elm = document.getElementById('esim_details');
    const urlParams = new URLSearchParams(window.location.search);
    const iccid = urlParams.get("iccid");

    let reqHead = { ...requestOptions, body: JSON.stringify({ "iccid": iccid }) };

    try {
        const response = await fetch(`${API_url}/api/fetchByICCID`, reqHead);
        const result = await response.json();

        let esimData = {
            smdpStatus: result[0].smdpStatus,
            esimStatus: result[0].esimStatus,
            orderUsage: result[0].orderUsage,
            eid: result[0].eid,
            pack_slug: result[0].packageList[0].slug
        };

        let esim_manual_details = extractLpaValues(result[0].ac);
        let esimStatusText = getEsimStatus(esimData, result[0].totalVolume);

        let isInstallable = !["Plan Expired - New eSIM Required", "eSIM Deleted", 'Plan Canceled - New eSIM Required','Active', 'Pending'].includes(esimStatusText);
        // let isInstalled = ['Active'].includes(esimStatusText);

        if (isInstallable) {
            esim_details_html += `
                <div class="esim_detail-card">
                    <div class="esim_install-img">
                        <img src="${result[0].qrCodeUrl}" alt="" width="150px" height="150px">
                        <small>iOS17.4+ Quick Installation</small>
                    </div>
                    <div class="esim_btn_wrapper"><a href="https://esimsetup.apple.com/esim_qrcode_provisioning?carddata=${result[0].ac}" class="esim_btn">Install</a></div>
                    <div class="esim_manual_details">
                        <p><span>Manual Activation</span></p>
                        <p><span>SM-DP+Address:</span><span>${esim_manual_details.first}</span></p>
                        <p><span>Activation Code:</span><span>${esim_manual_details.last}</span></p>
                    </div>
                </div>
            `;
        }

        esim_details_html += `
            <div class="esim_detail-card" style="gap:0;justify-content:normal; align-items: flex-start;">
                <div class="esim_detail-card_content">
                    <p><span>Status</span><span>${getEsimStatus(esimData, result[0].totalVolume)}</span></p>
                    <p><span>ICCID</span><span>${result[0].iccid}</span></p>
                    <p><span>Coverage</span><span>${getCountryName(result[0].packageList[0].locationCode, result[0].packageList[0].packageName)}</span></p>
                    <p><span>Expiry Date</span><span>${formatDateTime(result[0].expiredTime, "full")}</span></p>
                </div> 
                <div class="esim_details--data_content">
                    <p><span>Data Remaining</span><span>${formatBytes(Math.max(0, result[0].totalVolume - result[0].orderUsage))} / ${formatBytes(Math.max(0, result[0].totalVolume))}</span></p>
                    <div class="esim_progress_container">
                        <div class="esim_progress_bar"></div>
                    </div>
                </div>
            </div>
        `;

        esim_detail_elm.style.setProperty("--esim-progress", `${(Math.max(0, result[0].totalVolume - result[0].orderUsage) / result[0].totalVolume) * 100}%`);

        esim_detail_elm.closest('.container').querySelector('.esim_loader').classList.remove('esim_loader--active');
        esim_detail_elm.innerHTML = esim_details_html;
    } catch (error) {
        console.log('error esim_detail_page:', error);
    }
};

async function emptyNoteThenGoToCheckout(item){

    try {
        let cart_note = document.querySelectorAll('.cart-details-footer cart-note-modal form textarea[name="note"]');
        let data;

        if(cart_note.length == 0){
            const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ note: '' })
            });
            // console.log('in if con');
            
            if (!response.ok) { throw new Error(`Error: ${response.status} ${response.statusText}`); }
            data = await response.json();
            
        }
        item.type = 'submit'; item.click();

        // console.log('Cart note cleared:', data);
    } catch (error) { console.error('Failed to clear cart note:', error) }
}


if(document.getElementById('esim_list')){ window.eSim_fetch_data() }
if(document.getElementById('esim_details')){ esim_detail_page() }

document.addEventListener('click', (e) =>{
    const overlay = document.querySelector('.esim_topup_popup--overlay');
    if(e.target.closest('.esim_topup_popup--close_btn') || e.target.closest('.esim_topup_popup--overlay') ){ e.target.closest('.esim_topup_popup').style.display = 'none' }
    if(e.target.closest('.esim_card--btn.esim_card--top_up_btn')){ if(e.target.nextElementSibling != null ){ e.target.nextElementSibling.style.display = 'flex' } }
    
    // if(e.target.closest(`.cart-checkout-button[type="button"]`)){ console.log('emptyNoteThenGoToCheckout Entered'); emptyNoteThenGoToCheckout(e.target.closest(`.cart-checkout-button[type="button"]`)) }
})